<template>
  <div class="GameInfo">
    <div
      class="game_Progress_box"
      v-if="baseInfo && baseInfo.state && baseInfo.state != 4"
    ></div>

    <div class="info_box">
      <div class="nav">
        <div>
          <div>
            <a-menu
              mode="inline"
              :default-selected-keys="[selectedkeys]"
              :default-open-keys="['sub1']"
            >
              <router-link
                tag="span"
                :to="{ path: item.path, query: { appId: appId, id: id } }"
                v-for="(item, index) in menus"
                :key="index"
                v-if="item.meta.routers == 1"
              >
                <a-menu-item :key="item.meta.id">{{
                  $t("router." + [item.meta.title])
                }}</a-menu-item>
              </router-link>

              <a-sub-menu key="sub1">
                <span slot="title">
                  <span>{{ $t("router.Exploit_settings") }}</span>
                </span>
                <router-link
                  tag="span"
                  :to="{ path: item.path, query: { appId: appId, id: id } }"
                  v-for="(item, index) in menus"
                  :key="index"
                  v-if="item.meta.routers == 2"
                >
                  <a-menu-item :key="item.meta.id">{{
                    $t("router." + [item.meta.title])
                  }}</a-menu-item>
                </router-link>
              </a-sub-menu>
            </a-menu>
          </div>
        </div>
      </div>

      <div class="info_sub">
        <div class="game_top" v-if="baseInfo != ''"></div>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      appId: this.$route.query.appId,
      id: this.$route.query.id,
      selectedkeys: this.$route.meta.id,
      versions: "",
      state: this.$t("appinfo.state"),
      selects: 1,
    };
  },
  created() {
    console.log("this.$route.meta.title", this.$route.meta.title);
  },
  methods: {
    ...mapActions("user", ["tipMessage"]),
  },

  watch: {
    $route(to, from) {
      return (this.selectedkeys = to.meta.id);
    },
  },
  computed: {
    ...mapState("game", ["baseInfo"]),
    menus() {
      console.log(this.$router.options.routes[0].children[4].children);
      return this.$router.options.routes[0].children[4].children;
    },
  },
};
</script>

<style scoped="scoped">
.game_Progress_box {
  width: 1060px;
  position: relative;
  margin: 50px auto;
  display: flex;
  justify-content: space-between;
}
.game_Progress {
  width: 860px;
  height: 2px;
  position: absolute;
  top: 5px;
  left: 100px;
  background-color: #dddddd;
}
.game_Progress_wid {
  width: 432px;
  height: 2px;
  background-color: #4990fa;
}
.game_Progress_wid2 {
  height: 2px;
  background-color: #4990fa;
  width: 100%;
}

.game_Progress_centent {
  position: relative;
  z-index: 10;
  width: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.game_Progress_sum {
  width: 18px;
  height: 18px;
  background-color: #dddddd;
  border-radius: 50%;
  font-size: 12px;
  color: #ffffff;
  text-align: center;
  line-height: 18px;
}
.game_Progress_sum_active .game_Progress_sum {
  background-color: #4990fa;
}
.game_Progress_sum_active .game_Progress_text {
  color: #666666;
}
.game_Progress_text {
  margin-top: 14px;
  font-size: 14px;
  color: #aaaaaa;
}
.info_box {
  width: 1160px;
  /* height: 720px; */
  background-color: #ffffff;
  box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  margin: 40px auto 0;
  display: flex;
  margin-bottom: 105px;
}
.nav {
  width: 165px;
  background-color: #f3f3f3;
}
.nav_text {
  width: 165px;
  height: 52px;
  /* text-align: center; */
  padding-left: 34px;
  line-height: 52px;
}
.nav_text_active {
  box-sizing: border-box;

  border-left: 4px solid #4990fa;
  padding-left: 30px;
  background-color: #ffffff;
}
.info_sub {
  width: 1004px;
  height: 100%;
  padding-bottom: 94px;
}
.game_top {
  display: flex;
  padding: 0 0 10px 20px;
}
.game_url {
  width: 90px;
  height: 90px;
}
.game_img {
  width: 90px;
  height: 90px;
}
.game_info {
  margin-top: 5px;
  margin-left: 30px;
  font-size: 14px;
  color: #666666;
}
.game_info_text {
  line-height: 14px;
  margin-bottom: 16px;
}
.game_info .game_info_text:nth-last-of-type(1) {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/app/appInfo.vue